import { render } from "./Login.vue?vue&type=template&id=a1c5bcb4&scoped=true"
const script = {}

import "./Login.vue?vue&type=style&index=0&id=a1c5bcb4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c5bcb4"]])

export default __exports__